// src/websocket/subscription.ts
import { BaseSubscription } from './base_subscription';
export class Subscription extends BaseSubscription {
    constructor(channelConfig, websocketHandler, process = "subscribe") {
        super(channelConfig, websocketHandler, process);
    }
    listen(callback) {
        // replay buffered messages…
        this.messageBuffer.forEach((msgs, evt) => msgs.forEach(reqData => {
            callback({ event: evt, content: reqData.content });
            this.acknowledge(reqData, "CA");
        }));
        this.messageBuffer.clear();
        // then subscribe to all future events
        this.on("all", callback);
    }
    bind(event, callback) {
        // replay buffered for this event…
        (this.messageBuffer.get(event) || []).forEach(reqData => {
            callback(reqData.content);
            this.acknowledge(reqData, "CA");
        });
        this.messageBuffer.delete(event);
        // then subscribe to future
        this.on(event, callback);
    }
    remove(event, callback) {
        if (callback)
            this.off(event, callback);
        else
            this.removeAllListeners(event);
        this.messageBuffer.delete(event);
    }
    async push(event, data, options) {
        return super.push(event, data, options);
    }
    /**
     * Internal method to handle incoming messages for this subscription.
     * @param event The event name.
     * @param data The data received.
     */
    async handleMessage(event, data) {
        const { return_flag } = data;
        if (return_flag == "SA") {
            this.handleMessageAcks(event, return_flag, data);
            return;
        }
        this.acknowledge(data, "MA");
        if (this.channelConfig.channelType == "secure") {
            this.websocketHandler.pushForSecureLine("secured_public_key", {
                "username": data["from_username"]
            });
            let senderKey = await this.websocketHandler.listenForSecureLine('secured_public_key', (sdata) => {
                if (sdata['username'] !== data["from_username"]) {
                    return false;
                }
                if (sdata['status'] == 'unsuccessfull') {
                    throw Error(sdata['error']);
                }
                return true;
            });
            data['data'] = await this.websocketHandler.decrypt(data['data'], senderKey['public_key']);
        }
        let content = {};
        if (data.hasOwnProperty('data')) {
            content = JSON.parse(data['data']);
        }
        else {
            content = JSON.parse(data);
        }
        if (event === 'art_presence') {
            this.emit('art_presence', content);
        }
        else if (this.isSubscribed && event != 'art_presence') {
            const hasSpecific = this.listeners(event).length > 0;
            const hasAll = this.listeners("all").length > 0;
            if (hasSpecific || hasAll) {
                if (hasSpecific)
                    this.emit(event, content);
                if (hasAll)
                    this.emit("all", { event, content });
                this.acknowledge(data, "CA");
            }
            else {
                const buf = this.messageBuffer.get(event) || [];
                const { id, from, channel, to, pipeline_id, attempt_id, interceptor_name, to_username } = data;
                buf.push({
                    id, from, channel, to, pipeline_id, attempt_id, interceptor_name, to_username,
                    content
                });
                this.messageBuffer.set(event, buf);
            }
        }
    }
}
